import React from "react";

import ApplicationProcedureYTS from "./ApplicationProcedureYTS";
import CareerOptionsYTS from "./CareerOptionsYTS";
import EligibilityYTS from "./EligibilityYTS";
import ObjectivesYTS from "./ObjectivesYTS";
import OutcomesYTS from "./OutcomesYTS";
import OverviewYTS from "./OverviewYTS";

const YTS = () => {
  return (
    <div>
      <section id="overview" className="scroll-mt-40">
        <OverviewYTS />
      </section>
      <section id="objectives" className="scroll-mt-40">
        <ObjectivesYTS />
      </section>
      <section id="eligibility" className="scroll-mt-40">
        <EligibilityYTS />
      </section>
      <section id="application-procedure" className="scroll-mt-40">
        <ApplicationProcedureYTS />
      </section>
      <section id="career-options" className="scroll-mt-40">
        <CareerOptionsYTS />
      </section>
      <section id="outcomes" className="scroll-mt-40">
        <OutcomesYTS />
      </section>
    </div>
  );
};

export default YTS;
